import React from "react";
import { useMsal, AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

import Button from '@mui/material/Button';

import { useSelector } from 'react-redux';

export default function () {

    const { instance } = useMsal();

    return (
        <>
            <UnauthenticatedTemplate>
                <Button
                    onClick={() => instance.loginRedirect(loginRequest)}
                    fullWidth
                    variant="contained"
                    color="primary" >
                    login
                </Button>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
                <Button
                    onClick={() => instance.logoutRedirect({
                        postLogoutRedirectUri: "/",
                    })}
                    fullWidth
                    variant="contained"
                    color="primary" >
                    Salir
                </Button>
            </AuthenticatedTemplate>
        </>
    )


}

